import Main from "~/js/Main";

if (typeof TheeTheme !== undefined) {
    window.thee = new Main();
    window.thee.path.tpl = TheeTheme.path.tpl;
    window.thee.url.tpl = TheeTheme.url.tpl;
    window.thee.url.ajax = TheeTheme.url.ajax;
    window.thee.url.home = TheeTheme.url.home;
}